<div class="width-100 height-100 afericoes-historicos">
  <uib-tabset active="wrap.activeTab" class="tabset">
    <uib-tab heading="Semeadura" index="'semeadura_afericao'" select="wrap.activate('semeadura_afericao')">
      <div ng-controller="HistoricoAfericoesSemeaduraCtrl as afericoes">
        <div class="container-header">
          <div class="title text-center">
            <h2>
              <strong>AFERIÇÕES DE SEMEADURA</strong>
            </h2>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
            <button type="button" class="btn" uib-dropdown-toggle>
              {{afericoes.filters.safra.descricao || 'Safra' | characters:12}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
              <li role="menuitem" ng-show="afericoes.filters.safra">
                <a ng-click="afericoes.setFilterAttribute('safra', null, $event)" href="#">Todas</a>
              </li>
              <li class="divider" ng-show="afericoes.filters.safra"></li>
              <li role="menuitem" ng-repeat="safra in $root.safras | orderBy: '-descricao'">
                <a ng-click="afericoes.setFilterAttribute('safra', safra, $event)" href="#">{{::safra.descricao}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
            <button type="button" class="btn" uib-dropdown-toggle>
              {{afericoes.filters.implemento.descricao || 'Implemento' | characters:12}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
              <li role="menuitem" ng-show="afericoes.filters.implemento">
                <a ng-click="afericoes.setFilterAttribute('implemento', null, $event)" href="#">Todas</a>
              </li>
              <li class="divider" ng-show="afericoes.filters.implemento"></li>
              <li role="menuitem" ng-repeat="implemento in afericoes.maquinas | orderBy: 'descricao'">
                <a ng-click="afericoes.setFilterAttribute('implemento', implemento, $event)" href="#">{{::implemento.descricao}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
            <button type="button" class="btn" uib-dropdown-toggle>
              {{afericoes.filters.atividade.descricao || 'Cultura' | characters:12}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
              <li role="menuitem" ng-show="afericoes.filters.atividade">
                <a ng-click="afericoes.setFilterAttribute('atividade', null, $event)" href="#">Todas</a>
              </li>
              <li class="divider" ng-show="afericoes.filters.atividade"></li>
              <li role="menuitem" ng-repeat="atividade in afericoes.atividades | orderBy: 'descricao'">
                <a ng-click="afericoes.setFilterAttribute('atividade', atividade, $event)" href="#">{{::atividade.descricao}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn">
              {{(afericoes.filters.gleba.descricao || 'Talhão') | capitalize | characters:10}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
              <li role="menuitem" ng-show="afericoes.filters.gleba">
                <a ng-click="afericoes.setFilterAttribute('gleba', null, $event)" href="#">Todas</a>
              </li>
              <li role="menuitem" ng-repeat="gleba in $root.currentPropriedade.glebas | orderBy:'descricao' track by gleba.id">
                <a ng-click="afericoes.setFilterAttribute('gleba', gleba, $event)" href="#">{{::gleba.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn">
              {{afericoes.filters.tipo | capitalize}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
              <li>
                <a ng-click="afericoes.setFilterAttribute('tipo', 'semente')">Semente</a>
              </li>
              <li>
                <a ng-click="afericoes.setFilterAttribute('tipo', 'adubo')">Adubo</a>
              </li>
              <li>
                <a ng-click="afericoes.setFilterAttribute('tipo', 'gema')">Gemas</a>
              </li>
            </ul>
          </div>
          <!-- Fim Filtros -->
          <br><br>
        </div>

        <div class="container-body">
          <p class="text-center" ng-show="afericoes.afericoes && !afericoes.afericoes.length && !afericoes.loadingAfericoes">
            <small>Nenhuma aferição...</small>
          </p>

          <span class="input-group-addon no-border no-background" ng-show="afericoes.loadingAfericoes">
            <i class="fa fa-spinner fa-spin"></i>
          </span>
          <uib-accordion id="list-afericoes" ng-show="afericoes.afericoes.length" class="afericoes-historicos">
            <div
              infinite-scroll="afericoes.list()"
              infinite-scroll-parent="true"
              infinite-scroll-disabled="!afericoes.initialized"
            >
              <div
                ng-repeat="afericao in afericoes.afericoes"
                class="card-list"
                ng-class="{
                  'active': afericao.selected
                }"
              >
                <div
                  class="panel-default panel pointer"
                  ng-click="afericoes.selectAfericao(afericao)"
                >
                  <div role="tab" class="panel-heading">
                    <div class="float-data ng-scope">
                      <div class="text-cinza ng-binding ng-scope">
                        {{afericoes.filters.tipo | capitalize}}
                        <i class="fa fa-calendar"></i>
                        {{afericao.data_inicial | date:'dd/MM/yy'}} à {{afericao.data_final | date:'dd/MM/yy'}}
                      </div>
                    </div>

                    <h3>
                      <strong>{{afericao.descricao | capitalize}}</strong>
                    </h3>
                    <small>{{afericao.descricao_gleba}}</small>
                    <span ng-if="afericao.tipo !== 2">
                      <h5 class="text-cinza no-margin">Máxima: <b>{{afericao.maxima | number}} {{afericao.tipo === 0 && afericao.tipo_medida !== 'peso' ? 'sementes/ha' : 'kg/ha'}}</b></h5>
                      <h5 class="text-cinza no-margin">Média: <b>{{afericao.media | number}} {{afericao.tipo === 0 && afericao.tipo_medida !== 'peso' ? 'sementes/ha' : 'kg/ha'}}</b></h5>
                      <h5 class="text-cinza no-margin">Mínima: <b>{{afericao.minima | number}} {{afericao.tipo === 0 && afericao.tipo_medida !== 'peso' ? 'sementes/ha' : 'kg/ha'}}</b></h5>
                    </span>
                    <span ng-if="afericao.tipo === 2">
                      <h5 class="text-cinza no-margin">Total gemas: <b>{{afericao.objeto.totais_cana.total_gemas | number}}</b></h5>
                      <h5 class="text-cinza no-margin">Viáveis: <b>{{afericao.objeto.totais_cana.total_viaveis | number}} - {{afericao.objeto.totais_cana.media_viaveis_por_metro | number:2}}/m</b></h5>
                      <h5 class="text-cinza no-margin">Não viáveis: <b>{{afericao.objeto.totais_cana.total_nao_viaveis | number}} ({{afericao.objeto.totais_cana.percentual_nao_viaveis | number:2}}%)</b></h5>
                    </span>
                    <h5 class="text-cinza no-margin">Pontos realizados: <b>{{afericao.pontos}}</b></h5>
                  </div>
                </div>
              </div>
            </div>
          </uib-accordion>
        </div>
      </div>
    </uib-tab>
    <uib-tab heading="Colheita" index="'colheita_afericao'" select="wrap.activate('colheita_afericao')">
      <div ng-controller="HistoricoAfericoesCtrl as afericoes">
        <div class="container-header">
          <div class="title text-center">
            <h2>
              <strong>AFERIÇÕES DE COLHEITA</strong>
            </h2>
          </div>
          <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
            <button type="button" class="btn" uib-dropdown-toggle>
              {{afericoes.filters.safra.descricao || 'Safra' | characters:12}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
              <li role="menuitem" ng-show="afericoes.filters.safra">
                <a ng-click="afericoes.setFilterAttribute('safra', null, $event)" href="#">Todas</a>
              </li>
              <li class="divider" ng-show="afericoes.filters.safra"></li>
              <li role="menuitem" ng-repeat="safra in $root.safras | orderBy: '-descricao'">
                <a ng-click="afericoes.setFilterAttribute('safra', safra, $event)" href="#">{{::safra.descricao}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
            <button type="button" class="btn" uib-dropdown-toggle>
              {{afericoes.filters.maquina.descricao || 'Maquina' | characters:12}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
              <li role="menuitem" ng-show="afericoes.filters.maquina">
                <a ng-click="afericoes.setFilterAttribute('maquina', null, $event)" href="#">Todas</a>
              </li>
              <li class="divider" ng-show="afericoes.filters.maquina"></li>
              <li role="menuitem" ng-repeat="maquina in afericoes.maquinas | orderBy: 'descricao'">
                <a ng-click="afericoes.setFilterAttribute('maquina', maquina, $event)" href="#">{{::maquina.descricao}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true">
            <button type="button" class="btn" uib-dropdown-toggle>
              {{afericoes.filters.atividade.descricao || 'Cultura' | characters:12}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
              <li role="menuitem" ng-show="afericoes.filters.atividade">
                <a ng-click="afericoes.setFilterAttribute('atividade', null, $event)" href="#">Todas</a>
              </li>
              <li class="divider" ng-show="afericoes.filters.atividade"></li>
              <li role="menuitem" ng-repeat="atividade in afericoes.atividades | orderBy: 'descricao'">
                <a ng-click="afericoes.setFilterAttribute('atividade', atividade, $event)" href="#">{{::atividade.descricao}}</a>
              </li>
            </ul>
          </div>

          <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
            <button type="button" class="btn">
              {{(afericoes.filters.gleba.descricao || 'Talhão') | capitalize | characters:10}} <span class="caret"></span>
            </button>
            <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
              <li role="menuitem" ng-show="afericoes.filters.gleba">
                <a ng-click="afericoes.setFilterAttribute('gleba', null, $event)" href="#">Todas</a>
              </li>
              <li role="menuitem" ng-repeat="gleba in $root.currentPropriedade.glebas | orderBy:'descricao' track by gleba.id">
                <a ng-click="afericoes.setFilterAttribute('gleba', gleba, $event)" href="#">{{::gleba.descricao | capitalize}}</a>
              </li>
            </ul>
          </div>
          <!-- Fim Filtros -->
          <br><br>
        </div>

        <div class="container-body">
          <p class="text-center" ng-show="afericoes.afericoes && !afericoes.afericoes.length && !afericoes.loadingAfericoes">
            <small>Nenhuma aferição...</small>
          </p>

          <span class="input-group-addon no-border no-background" ng-show="afericoes.loadingAfericoes">
            <i class="fa fa-spinner fa-spin"></i>
          </span>

          <uib-accordion id="list-afericoes" ng-show="afericoes.afericoes.length" class="afericoes-historicos">
            <div
              infinite-scroll="afericoes.list()"
              infinite-scroll-parent="true"
              infinite-scroll-disabled="!afericoes.initialized"
            >
              <div
                ng-repeat="afericao in afericoes.afericoes"
                class="card-list"
                ng-class="{
                  'active': afericao.selected
                }"
              >
                <div
                  class="panel pointer"
                  ng-click="afericoes.selectAfericao(afericao)"
                >
                  <div role="tab" class="panel-heading">
                    <div class="float-data ng-scope">
                      <div class="text-cinza ng-binding ng-scope">
                        <i class="fa fa-calendar"></i>
                        {{afericao.data_inicial | date:'dd/MM/yy'}} à {{afericao.data_final | date:'dd/MM/yy'}}
                      </div>
                    </div>

                    <h3>
                      <strong>{{afericao.descricao | capitalize}}</strong>
                    </h3>
                    <small>{{afericao.descricao_gleba}}</small>

                    <h5 class="text-cinza no-margin">Perda máxima: <strong>{{afericao.maxima | number}} kg/ha</strong></h5>
                    <h5 class="text-cinza no-margin">Perda mínima: <strong>{{afericao.minima | number}} kg/ha</strong></h5>
                    <h5 class="text-cinza no-margin">Perda média: <strong>{{afericao.media | number}} kg/ha</strong></h5>
                    <h5 class="text-cinza no-margin">Pontos realizados: <strong>{{afericao.pontos}}</strong></h5>
                  </div>
                </div>
              </div>
            </div>
          </uib-accordion>
        </div>
      </div>
    </uib-tab>
  </uib-tabset>
</div>
